/* eslint semi:0 */
import ModalVm from 'vms/ModalVm'
import BaseClass from 'application/BaseClass'
import EmptyView from 'views/EmptyView'
import ModalStore from 'stores/ModalStore'
import { make as makeComponent, } from 'utils/component'

class ModalController extends BaseClass {

  constructor(options = {}){
    super(options);
    let store = options.store || ModalStore.create(options);
    this.merge({
      vm: ModalVm.create(Object.assign({}, options, { store, })),
      store,
    });
  }

}

export default makeComponent(ModalController, EmptyView);


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/components/modalComponent.js